import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';

import KeyValueRow from 'components/purchase-order/KeyValueRow';

const VendorViewMode = ({ vendor, isEditing, handleEditClick }) => {
  const vendorRequest = vendor?.vendor_request;

  return (
    <>
      {/* General Details, Contact Details */}
      <div className="position-relative mb-3 pb-3 border-bottom border-dotted">
        <Row>
          <Col md={4}>
            <h5 className="mb-3 fs-9">General Details</h5>

            <KeyValueRow label="Vendor Code" value={vendor?.vendor_code} />

            <KeyValueRow
              label="Vendor Name"
              value={vendor?.name}
              requestedValue={vendorRequest?.name}
            />

            <KeyValueRow
              label="Corporation Number"
              value={vendor?.corporation_number}
              requestedValue={vendorRequest?.corporation_number}
            />

            <KeyValueRow
              label="Business Registration Number"
              value={vendor?.business_registration_number}
              requestedValue={vendorRequest?.business_registration_number}
            />
          </Col>

          <Col md={4}>
            <h5 className="mb-3 fs-9">Contact Details</h5>

            <KeyValueRow
              label="Contact Name"
              value={vendor?.contact_name}
              requestedValue={vendorRequest?.contact_name}
            />

            <KeyValueRow
              label="Email ID"
              value={vendor?.contact_email}
              requestedValue={vendorRequest?.contact_email}
            />

            <KeyValueRow
              label="Phone Number"
              value={vendor?.contact_phone}
              requestedValue={vendorRequest?.contact_phone}
            />
          </Col>
        </Row>

        {!isEditing && (
          <Button
            className="position-absolute top-0 end-0 w-auto"
            variant="outline-secondary"
            size="sm"
            onClick={handleEditClick}
          >
            Edit
          </Button>
        )}
      </div>

      {/* Accounting Details */}
      <div className="mb-3 pb-3 border-bottom border-dotted">
        <h5 className="mb-3 fs-9">Accounting Details</h5>

        <Row>
          <Col md={4}>
            <KeyValueRow
              label="PAN"
              value={vendor?.pan}
              requestedValue={vendorRequest?.pan}
            />
            <KeyValueRow
              label="TIN"
              value={vendor?.tin}
              requestedValue={vendorRequest?.tin}
            />
            <KeyValueRow
              label="GSTIN"
              value={vendor?.gstin}
              requestedValue={vendorRequest?.gstin}
            />
          </Col>

          <Col md={4}>
            <KeyValueRow
              label="Tax Exempted"
              value={vendor?.is_tax_free}
              requestedValue={vendorRequest?.is_tax_free}
            />
            <KeyValueRow
              label="TCS Addition Enabled"
              value={vendor?.is_tcs_addition_enable}
              requestedValue={vendorRequest?.is_tcs_addition_enable}
            />
            <KeyValueRow
              label="Accepts CForm"
              value={vendor?.is_accepts_cform}
              requestedValue={vendorRequest?.is_accepts_cform}
            />
          </Col>

          <Col md={4}>
            <KeyValueRow
              label="Currency"
              value={vendor?.currency}
              requestedValue={vendorRequest?.currency}
            />

            <KeyValueRow
              label="Purchase Expiry Period"
              value={vendor?.purchase_expiry_period}
              requestedValue={vendorRequest?.purchase_expiry_period}
            />
          </Col>
        </Row>
      </div>

      {/* Billing Address */}
      <div>
        <h5 className="mb-3 fs-9">Billing Address</h5>

        <Row>
          <Col md={4}>
            <KeyValueRow
              label="Address Line 1"
              value={vendor?.contact_address_line_1}
              requestedValue={vendorRequest?.contact_address_line_1}
            />

            <KeyValueRow
              label="Address Line 2"
              value={vendor?.contact_address_line_2}
              requestedValue={vendorRequest?.contact_address_line_2}
            />

            <KeyValueRow
              label="Country"
              value={vendor?.contact_country}
              requestedValue={vendorRequest?.contact_country}
            />
          </Col>

          <Col md={4}>
            <KeyValueRow
              label="State"
              value={vendor?.contact_state}
              requestedValue={vendorRequest?.contact_state}
            />

            <KeyValueRow
              label="City"
              value={vendor?.contact_city}
              requestedValue={vendorRequest?.contact_city}
            />

            <KeyValueRow
              label="Pin Code"
              value={vendor?.contact_pincode}
              requestedValue={vendorRequest?.contact_pincode}
            />
          </Col>
        </Row>
      </div>
    </>
  );
};

export default VendorViewMode;
